// Името и телефонът на госта — чиста логика без React (тестове:
// guestFields.test.ts). Огледало на BE валидацията на create/update
// (app/features/reservations/schemas.py); правилата са описани в
// docs/cross-repo-contract.md §Резервации. Смениш ли ги — и в BE.

// Буква в началото или след интервал/тире („иванова-петрова" → „Иванова-Петрова").
const WORD_START = /(^|[\s-])(\p{L})/gu;

/**
 * Главна буква в началото на всяка дума (и след тире) — докато се пише.
 * Останалите букви не се пипат („МакДоналд" остава), интервалите също
 * (иначе интервалът между думите изчезва, докато се пише).
 */
export const capitalizeGuestName = (value: string) =>
  value.replace(WORD_START, (_, separator: string, letter: string) => separator + letter.toLocaleUpperCase());

/**
 * Името, както се записва: без интервали в краищата, многото интервали —
 * един, главни букви като `capitalizeGuestName`. Същата функция в BE.
 */
export const normalizeGuestName = (value: string) => capitalizeGuestName(value.trim().replace(/\s+/g, " "));

const MIN_NAME_LETTERS = 2;
const PHONE_ALLOWED = /^[0-9 +\-()]*$/;
export const MIN_PHONE_DIGITS = 6;
export const MAX_PHONE_DIGITS = 15;

/** Грешка в полето: ключ на превода под `reservations.form.errors.*`; null — наред. */
export type GuestFieldError = "nameRequired" | "phoneInvalid";

/** Името има поне 2 букви (цифрите и знаците не се броят). */
export const guestNameError = (value: string): GuestFieldError | null =>
  (value.match(/\p{L}/gu)?.length ?? 0) >= MIN_NAME_LETTERS ? null : "nameRequired";

/** Телефонът: само цифри, интервал, +, -, (, ) и 6–15 цифри. */
export const phoneError = (value: string): GuestFieldError | null => {
  const trimmed = value.trim();
  if (!PHONE_ALLOWED.test(trimmed)) return "phoneInvalid";
  const digits = trimmed.replace(/\D/g, "").length;
  return digits >= MIN_PHONE_DIGITS && digits <= MAX_PHONE_DIGITS ? null : "phoneInvalid";
};
